export type JourneyPhase =
    | "ADDRESS"
    | "PRE_APPROVAL"
    | "SCHEME_SELECTION"
    | "REJECTED"
    | "NATIVE"
    | "COMPLETED";

export function getRouteForPhase(phase: JourneyPhase | string): string {
    switch (phase) {
        case "ADDRESS":
            return "/naddress";
        case "PRE_APPROVAL":
            return "/napproval";
        case "SCHEME_SELECTION":
            return "/nscheme-selection";
        case "REJECTED":
            return "/nrejected";
        case "NATIVE":
        case "COMPLETED":
        default:
            return "/ndashboard";
    }
}